var _path, _path2, _g, _g2, _g3, _g4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessagesIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 107,
    height: 73,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.864 49.475L90.993 0H49.475L0 49.475h41.864z",
    fill: "#333330"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.779 64.006L107 15H65.5L15.915 64.006h41.864z",
    fill: "#d60e15"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#A)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M79.124 26.986a4 4 0 014 4v23.721a4 4 0 01-4 4h-3.609l.854 9.105-9.959-9.105H46.592a4 4 0 01-4-4V30.986a4 4 0 014-4h32.532z",
    fill: "#e0e0e0"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#999"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.678,
    height: 2.076,
    rx: 1.038,
    transform: "matrix(-1 0 0 1 79.574 47.053)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.574 52.935a1.04 1.04 0 00-1.038-1.038H60.545a1.04 1.04 0 00-1.038 1.038 1.04 1.04 0 001.038 1.038h17.991a1.04 1.04 0 001.038-1.038z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#B)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M26.766 4.844a4 4 0 00-4 4v30.312a4 4 0 004 4h5.19l-1.031 10.998 12.029-10.998H67.72a4 4 0 004-4V8.844a4 4 0 00-4-4H26.766z",
    fill: "#fff"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9,
    fill: "#333"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.755,
    y: 14.53,
    width: 34.598,
    height: 2.076,
    rx: 1.038
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.755,
    y: 19.374,
    width: 27.678,
    height: 2.076,
    rx: 1.038
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.755 25.256a1.04 1.04 0 011.038-1.038h9.688a1.04 1.04 0 011.038 1.038 1.04 1.04 0 01-1.038 1.038h-9.687a1.04 1.04 0 01-1.038-1.038z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "A",
    x: 40.592,
    y: 25.986,
    width: 44.532,
    height: 44.826,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "A"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "B"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "B",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "A"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "B",
    x: 20.766,
    y: 3.844,
    width: 52.954,
    height: 53.309,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "A"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "B"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "B",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "A"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic"
  })))));
}
SvgMessagesIcon.displayName = 'MessagesIcon';
export default SvgMessagesIcon;